import { render, staticRenderFns } from "./enterprises.vue?vue&type=template&id=640432a2&"
import script from "./enterprises.vue?vue&type=script&lang=js&"
export * from "./enterprises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports